<template>
  <div class="login-wrapper">
    <div class="login-card">
      <h1 class="title">동영상 업로드 로그인 </h1>
      <p class="subtitle">센터 로그인</p>
      
      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label for="userid">User ID</label>
          <input 
            type="text" 
            id="userid" 
            v-model="userid" 
            placeholder="ID는 핸드폰번오에서 - 를 뺀 숫자입니다."
            required
          >
        </div>
        
        <div class="form-group">
          <label for="password">Password</label>
          <input 
            type="password" 
            id="password" 
            v-model="password" 
            placeholder="비밀번호를 입력해주세요. ( 초기 비번은 ID와 동일합니다. )"
            required
          >
        </div>

        <button type="submit" class="login-btn" :disabled="isLoading">
          <span v-if="!isLoading">로그인</span>
          <span v-else>로그인 중...</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { _baseURL } from '@/config/api';

export default {
  name: 'LoginPage',
  data() {
    return {
      userid: '',
      password: '',
      isLoading: false
    }
  },
  methods: {
    async handleLogin() {
      if (!this.userid || !this.password) return;

      this.isLoading = true;
      try {
        const response = await axios.post(`${_baseURL}User/logincenter`, {
          centeridx: 0,
          authkey: '',
          userid: this.userid,
          password: this.password
        });

        if (response.data.ret === 10) {
          alert('회원가입이 필요합니다.');
          localStorage.setItem('registcenteridx', response.data.centeridx);
          localStorage.setItem('authkey', response.data.authkey);
          this.$router.push('/register');
          return;
        }

        const centeridx = response.data.centeridx;
        const ret = response.data.ret;

        if (ret === 1 && centeridx > 0) {
          localStorage.setItem('isLoggedIn', 'true');
          localStorage.setItem('centeridx', centeridx); // Store centeridx
          this.$router.push('/upload');
        } else {
          alert('로그인 실패: 아이디 또는 비밀번호를 확인해주세요.');
        }
      } catch (error) {
        console.error('Login error:', error);
        alert('An error occurred during login. Please try again.');
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.login-card {
  background: var(--surface-dark);
  padding: 3rem;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.title {
  color: var(--text-light);
  font-size: 2rem;
  margin-bottom: 0.5rem;
  font-weight: 700;
}

.subtitle {
  color: var(--text-muted);
  margin-bottom: 2rem;
}

.form-group {
  margin-bottom: 1.5rem;
  text-align: left;
}

label {
  display: block;
  color: var(--text-muted);
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

input {
  width: 100%;
  padding: 0.75rem 1rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: var(--text-light);
  font-size: 1rem;
  outline: none;
  transition: all 0.2s;
  box-sizing: border-box; 
}

input:focus {
  border-color: var(--primary-color);
  background: rgba(255, 255, 255, 0.1);
}

.login-btn {
  width: 100%;
  padding: 0.875rem;
  background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.login-btn:hover {
  opacity: 0.9;
}

.login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
